<template>
    <div class="flex justify-between items-center max-h-9">
        <div class="flex items-center gap-3">
            <UserAvatar
                :diameterPx="36"
                userName="Julia"
            />

            <div class="flex flex-col justify-between">
                <span class="text-[14px] leading-[17px] text-won-dark-blue">
                    {{ userName }}
                </span>
                
                <span
                    class="text-[12px] leading-[14px] text-won-dark block mt-1"
                >
                    {{ userEmail }}
                </span>
            </div>
        </div>

	    <div class="flex items-center gap-2">
	        <AccessPreviewMenu
	            :options="options"
	            :displayMap="displayMap"
	            v-model="userPermission"
	        />

		    <TrashIcon
		        class="size-4 text-won-ash-gray cursor-pointer"
		        @click="removeUserHandler"
		    />
	    </div>
    </div>
</template>

<script setup>
import { toRefs, ref, watch } from "vue";
import { useResumeShare } from "../../store/share-resume.store";

import UserAvatar from "../library/user-avatar.vue";
import AccessPreviewMenu from "./access-preview-menu.vue";

import { TrashIcon } from "@heroicons/vue/24/outline"

const emit = defineEmits(['permission:update']);
const props = defineProps({
    userEmail: {
        type: String,
        default: null
    },
    userName: {
        type: String,
        required: true
    },
    permission: {
        type: String,
        default: null
    },
	userId: {
		type: Number,
		default: null
	},
    userRights: {
        type: Object,
        default: null
    },
    options: {
        type: Array,
        default: []
    },
    displayMap: {
        type: Object,
        default: {}
    }
})
const { userName, userEmail, permission, userId } = toRefs(props)
const userPermission = ref(permission.value);

const resumeShareStore = useResumeShare();

const removeUserHandler = () => {
	resumeShareStore.setShowRemoveUserModal({
		userId: userId.value,
		email: userEmail.value
	})
}

watch(userPermission, (newPermission) => {
    emit("permission:update", newPermission);
})
</script>
